import { useBenefitProductsList } from '@ben/api/gen/codegen';
import Select from '@ben/orion/select';
import { Controller, useFormContext } from 'react-hook-form';

const BenefitProductSelect = () => {
  const { control } = useFormContext();

  const { data: products } = useBenefitProductsList();

  return (
    <Controller
      name="product"
      control={control}
      rules={{ required: false }}
      render={({ field }) => {
        const { value, onChange } = field;
        const stringValue = value?.toString();
        return (
          <Select
            onChange={onChange}
            data={
              products?.map((product) => ({
                label: product.name,
                value: product.id.toString(),
              })) ?? []
            }
            label="Benefit product (optional)"
            value={stringValue}
            searchable
            width="100%"
          />
        );
      }}
    />
  );
};

export default BenefitProductSelect;
